import React, { useEffect, useState } from "react";
import useWPOptionMutation from "../hooks/useWPOptionMutation";
import useWPOptionQuery from "../hooks/useWPOptionQuery";
import BodyContents from "./BodyContents/BodyContents";
import SideBar from "./SideBar/SideBar";
import WPHeader from "./WPHeader/WPHeader";
import "./style.scss";

const Dashboard = ({ name, items, saveCallback = false }) => {
  const [activeItem, setActiveItem] = useState(items[0].name);

  const [data, setData] = useState({});
  const { data: firstData = {}, isLoading: loadingOnGet } = useWPOptionQuery(name);
  const { isLoading: loadingOnSet, saveData } = useWPOptionMutation(name, { dataType: 'object' });

  // Get first data
  useEffect(() => {
    if (!loadingOnGet) {
      setData({ ...firstData });
    }
  }, [loadingOnGet]);

  // Save to database
  const onSaveData = () => {
    if (!loadingOnSet) {
      saveData({ ...data });
      saveCallback && saveCallback(data);
    }
  }

  return <div className="bpwsnbDashboard">
    <div className="wp-dashboard-main" >
      <SideBar items={items} activeItem={activeItem} setActiveItem={setActiveItem} />

      <div className="wp-dashboard-bodycontent-mainWrapper">
        <WPHeader items={items} activeItem={activeItem} loading={loadingOnSet} onSaveData={onSaveData} />
        <BodyContents items={items} activeItem={activeItem} data={data} setData={setData} />
      </div>
    </div>
  </div>
};
export default Dashboard;